import Masonry from 'masonry-layout';

//console.log('masonry tesrt');
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('[data-gallery="masonry"]').forEach(function (area) {
        Promise.all(Array.from(area.querySelectorAll('img')).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
            console.log('images finished loading');
            console.log('test');
            console.log(Date.now());
        }).then(() => {
            new Masonry( area, {
              itemSelector: '[data-gallery="item"]',
              percentPosition: true,
            });
        });
    });
});


